import { CampaignStatusFilter } from './campaign-status'

/**
 * Campaign status icons from the Figma campaign-selector redesign (DEV-2437,
 * App DS file `vnDpQZkYlTZlXDsMv7OrF6`, nodes 9520:17262 / 10817:11884):
 * Active = green check-circle, Paused = gray pause-circle, Removed = red
 * x-circle. Fills are the exact values from the Figma export and stay fixed
 * across themes — these are status colors, not surface-dependent tokens.
 */
const STATUS_ICON_PATHS: Record<CampaignStatusFilter, { fill: string; d: string }> = {
	ACTIVE: {
		fill: '#17B26A',
		d: 'M8.00033 0.666992C3.95024 0.666992 0.666992 3.95024 0.666992 8.00033C0.666992 12.0504 3.95024 15.3337 8.00033 15.3337C12.0504 15.3337 15.3337 12.0504 15.3337 8.00033C15.3337 3.95024 12.0504 0.666992 8.00033 0.666992ZM11.4717 6.47173C11.7321 6.21138 11.7321 5.78927 11.4717 5.52892C11.2114 5.26857 10.7893 5.26857 10.5289 5.52892L7.00033 9.05752L5.47173 7.52892C5.21138 7.26857 4.78927 7.26857 4.52892 7.52892C4.26857 7.78927 4.26857 8.21138 4.52892 8.47173L6.52892 10.4717C6.78927 10.7321 7.21138 10.7321 7.47173 10.4717L11.4717 6.47173Z'
	},
	PAUSED: {
		fill: '#9F9EA3',
		d: 'M8.00033 0.666992C3.95024 0.666992 0.666992 3.95024 0.666992 8.00033C0.666992 12.0504 3.95024 15.3337 8.00033 15.3337C12.0504 15.3337 15.3337 12.0504 15.3337 8.00033C15.3337 3.95024 12.0504 0.666992 8.00033 0.666992ZM7.00033 6.00033C7.00033 5.63214 6.70185 5.33366 6.33366 5.33366C5.96547 5.33366 5.66699 5.63214 5.66699 6.00033V10.0003C5.66699 10.3685 5.96547 10.667 6.33366 10.667C6.70185 10.667 7.00033 10.3685 7.00033 10.0003V6.00033ZM10.3337 6.00033C10.3337 5.63214 10.0352 5.33366 9.66699 5.33366C9.2988 5.33366 9.00033 5.63214 9.00033 6.00033V10.0003C9.00033 10.3685 9.2988 10.667 9.66699 10.667C10.0352 10.667 10.3337 10.3685 10.3337 10.0003V6.00033Z'
	},
	REMOVED: {
		fill: '#F04438',
		d: 'M8.00033 0.666992C3.95024 0.666992 0.666992 3.95024 0.666992 8.00033C0.666992 12.0504 3.95024 15.3337 8.00033 15.3337C12.0504 15.3337 15.3337 12.0504 15.3337 8.00033C15.3337 3.95024 12.0504 0.666992 8.00033 0.666992ZM10.4717 5.52892C10.7321 5.78927 10.7321 6.21138 10.4717 6.47173L8.94313 8.00033L10.4717 9.52892C10.7321 9.78927 10.7321 10.2114 10.4717 10.4717C10.2114 10.7321 9.78927 10.7321 9.52892 10.4717L8.00033 8.94313L6.47173 10.4717C6.21138 10.7321 5.78927 10.7321 5.52892 10.4717C5.26857 10.2114 5.26857 9.78927 5.52892 9.52892L7.05752 8.00033L5.52892 6.47173C5.26857 6.21138 5.26857 5.78927 5.52892 5.52892C5.78927 5.26857 6.21138 5.26857 6.47173 5.52892L8.00033 7.05752L9.52892 5.52892C9.78927 5.26857 10.2114 5.26857 10.4717 5.52892Z'
	}
}

interface CampaignStatusIconProps {
	status: CampaignStatusFilter
	className?: string
}

export const CampaignStatusIcon = ({
	status,
	className
}: CampaignStatusIconProps) => {
	const icon = STATUS_ICON_PATHS[status]
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={`shrink-0 ${className ?? ''}`}
			aria-label={`${status.toLowerCase()} status`}
			role="img"
		>
			<path fillRule="evenodd" clipRule="evenodd" d={icon.d} fill={icon.fill} />
		</svg>
	)
}
